import  React, {use, useState, useEffect} from 'react';
import MenuBar from "../components/MenuBar";
import "./styles/AdminPanel.css";
import "./styles/estandar/ButtonStyles.css";

import { FaUsers } from "react-icons/fa";
import { FaPlusCircle } from "react-icons/fa";

import CreateUserForm from '../components/CreateUserForm';
import ListUsers from '../components/ListUsers';
import Cookies from 'js-cookie';
import { useNavigate, useParams } from "react-router-dom";
import { FaHistory } from "react-icons/fa";
import { IoMdHelpCircle } from "react-icons/io";

//RepPrA
const AdminPanel = () =>{

    const [panelOption, setPanelOption] = useState("listaUsuarios");
    const [titulo, setTitulo] = useState("Panel administración : Usuarios");

/*Funcion para validar el tipo de session*/

    const navigate = useNavigate();
    
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else{
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                Cookies.remove("turid");
                Cookies.remove("usr");
                navigate("/");
            }
    }

    
    useEffect(() =>{
        validarSesion();
    },[])



    const handlePanelUsuarios = () =>{
        setTitulo("Panel administración : Usuarios");
        setPanelOption("listaUsuarios");
    }
    const handlePanelCrearUsuarios = () =>{
        setTitulo("Panel administración : Crear usuario");
        setPanelOption("crearUsuario");
    }

    const handleLogList = () =>{
        navigate("/logs");
    }

    const handleAyudaAdmin = () =>{
        navigate("/ayudaAdmin");
    }



    return(
        <div>
            <MenuBar pagina="adminPanel" sesion={admin}/>
            <div className="bodyAdminPanel">
                <h1 className="AdminPanelTitle">{titulo}</h1>
                <div className="AdminPanelCl">
                    <div className="optionsAdminPanel">
                        <button className="buttonStandart" onClick={handlePanelUsuarios}><FaUsers />Usuarios</button>
                        <button className="buttonStandart" onClick={handlePanelCrearUsuarios}><FaPlusCircle />Crear usuario</button>
                        <button className="buttonStandart" onClick={handleLogList}><FaHistory size="30px"/> Ver historial de modificaciones</button>
                        <button className="buttonStandart" onClick={handleAyudaAdmin}><IoMdHelpCircle size="18px"/>Ayuda</button>
                    </div>
                    <div className="contentAdminPanel">
                        {panelOption === "listaUsuarios" && <ListUsers/>}
                        {panelOption === "crearUsuario" && <CreateUserForm/>}
                        
                    </div>
                </div>
            </div>
            
            </div>
    );
}

export default AdminPanel;